import { tenantAwareApiWrapper, withServiceClient } from './portal-http';

import { interactClient } from '@terra/shared-rest-clients-interact';
import type {
  InteractContract} from '@terra/shared-contracts-interact';
import {
  type DynamicResponseConfig,
} from '@terra/shared-contracts-interact';

export const portalInteractApi = {
  generateInteractLink: () =>
    tenantAwareApiWrapper<typeof InteractContract.generateLink>({
      endpointFn: (headers) =>
        interactClient.generateLink({
          ...withServiceClient(headers, 'attacker'),
        }),
    }),

  resumeInteractSession: (sessionId: string) =>
    tenantAwareApiWrapper<typeof InteractContract.resumeSession>({
      endpointFn: (headers) =>
        interactClient.resumeSession({
          params: { sessionId },
          ...withServiceClient(headers, 'attacker'),
        }),
    }),

  getInteractInteractions: (sessionId: string) =>
    tenantAwareApiWrapper<typeof InteractContract.getInteractions>({
      endpointFn: (headers) =>
        interactClient.getInteractions({
          params: { sessionId },
          ...withServiceClient(headers, 'attacker'),
        }),
    }),

  stopInteractListener: (sessionId: string) =>
    tenantAwareApiWrapper<typeof InteractContract.stopListener>({
      endpointFn: (headers) =>
        interactClient.stopListener({
          params: { sessionId },
          ...withServiceClient(headers, 'attacker'),
        }),
    }),

  listInteractSessions: () =>
    tenantAwareApiWrapper<typeof InteractContract.listSessions>({
      endpointFn: (headers) =>
        interactClient.listSessions({
          ...withServiceClient(headers, 'attacker'),
        }),
    }),

  deleteInteractSession: (sessionId: string) =>
    tenantAwareApiWrapper<typeof InteractContract.deleteSession>({
      endpointFn: (headers) =>
        interactClient.deleteSession({
          params: { sessionId },
          ...withServiceClient(headers, 'attacker'),
        }),
    }),

  setInteractDynamicResponse: (
    sessionId: string,
    config: DynamicResponseConfig,
  ) =>
    tenantAwareApiWrapper<typeof InteractContract.setDynamicResponse>({
      endpointFn: (headers) =>
        interactClient.setDynamicResponse({
          params: { sessionId },
          body: config,
          ...withServiceClient(headers, 'attacker'),
        }),
    }),

  // Memory endpoints
};
